import axios from 'axios';
import { formatResponse, formatError } from './formatResponse';
import { API_BASE_URL } from '../../constants/Constants';

const axiosConfig = {
  withCredentials: true,
};

const instanceAPI = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-type': 'application/json' },
  axiosConfig,
});

// Interceptor for when token is available, add it on request headers
// eslint-disable-next-line
/*
instanceAPI.interceptors.request.use(config => {
  const token = Cookies.get('jwt_clubpremier') ? Cookies.get('jwt_clubpremier') : '';
  // eslint-disable-next-line
  config.headers.common.Authorization = `Bearer ${token}`;
  return config;
});
*/

instanceAPI.interceptors.response.use(
  (response) => formatResponse(response),
  (error) => formatError(error),
);

export default instanceAPI;
